import type { ReactNode } from "react";

import type { IssueTypeValue } from "../libs/issue-types";
import type { AuthStatus } from "./auth-status";
import type { SupportGuideProps } from "./support-guide";

export interface DefaultConfiguration {
  apiKey?: string;
  apiURL?: string;
  authStatus?: AuthStatus;
  headers?: Record<string, string>;
  issueType?: IssueTypeValue;
  position?:
    | "bottom-left"
    | "bottom-right"
    | "left"
    | "right"
    | "top-left"
    | "top-right";
  sections?: Array<Section>;
  supportGuide?: SupportGuideProps;
}

export interface Section {
  icon?: ReactNode;
  id: ViewType;
  title: string;
  show?: boolean;
}

export const View = Object.freeze({
  Chat: "Chat",
  Feedback: "Feedback",
  Home: "Home",
  Info: "Info",
  Issue: "Issue",
});

export type ViewType = keyof typeof View;
